import EpisodeLegacyPage from './EpisodeLegacyPage';

export default EpisodeLegacyPage;
